import { render, staticRenderFns } from "./resident.vue?vue&type=template&id=e67db0a4&scoped=true"
import script from "./resident.vue?vue&type=script&lang=js"
export * from "./resident.vue?vue&type=script&lang=js"
import style0 from "./resident.vue?vue&type=style&index=0&id=e67db0a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67db0a4",
  null
  
)

export default component.exports